import { ICONS } from '_Components/Icons/Icon';

export default function getModuleIconPath(module) {
  if (!module) return undefined;
  const normalizedModule = module.toUpperCase();
  return ICONS[`MODULES_${normalizedModule}`];
}
